import { render, staticRenderFns } from "./RechercheLayout.vue?vue&type=template&id=aad66460&"
import script from "./RechercheLayout.vue?vue&type=script&lang=js&"
export * from "./RechercheLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports